// \ * + ? . ^ $ ( ) [ ] { } | / @
export function regexEscape(str) {
  return str.replace(/[\\.*+?^${}()[\]{}|@]/g, '\\$&').replace(/\//g, '\\/')
}

// \ . ^ $ * + ? ( ) [ ] { } | @ # & /
export function luceneEscape(str) {
  return str.replace(/[\\.^$*+?()[\]{}|@#&]/g, '\\$&').replace(/\//g, '\\/')
}

// \ “
export function kqlEscape(str: string): string {
  return str.replace(/[\\"]/g, '\\$&')
}

// % ‘
/**
 * Escapes special characters for use in AQL queries.
 * Specifically, it doubles single quotes and percent signs.
 *
 * @param str - The input string to escape.
 * @returns The escaped string.
 */
export function aqlEscape(str: string): string {
  return str
    .replace(/'/g, "''") // Escape single quotes by doubling them
    .replace(/%/g, '%%') // Escape percent signs by doubling them
}
